/**
 * Created by DemonRay on 2019/3/25.
 */

import cytoscape from '@qwoach/cytoscape'
import cytoscapeLayers from 'cytoscape-layers'
// import cytoscape from '../../cytoscape-genogram'
import utils from '../utils'
import EventBus from '../utils/eventbus'

import compoundDragAndDrop from 'cytoscape-compound-drag-and-drop';
import toolbar, {findCyEditorCommand} from './cyeditor-toolbar'
import snapGrid from './cyeditor-snap-grid'
import undoRedo from './cyeditor-undo-redo'
import clipboard from './cyeditor-clipboard'
import cynavigator from './cyeditor-navigator'
import edgehandles from './cyeditor-edgehandles'
import noderesize from './cyeditor-node-resize'
import editElements from './cyeditor-edit-elements'
import dragAddNodes from './cyeditor-drag-add-nodes'
import touchDragAddNodes from './cyeditor-touch-drag-add-nodes'
import contextMenu from './cyeditor-context-menu'
import nodeContextMenu from './cyeditor-node-context-menu'
import templates from './cyeditor-templates'
import {defaultConfData, defaultEditorConfig, defaultNodeTypes} from '../defaults'
import GenogramRenderer from './GenogramRenderer'
import edgeConnections from 'cytoscape-edge-connections';
import {
	resolveLineTypeItemByLineType,
	straightLine
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/cyeditor-edit-elements/LineTypeItem";
import KeyActionListener from "@/core/js/helpers/KeyActionListener";
import {asArray, delay, ensureArray, isDevEnv, timeNow, uuidv4} from "@/utils/helpers";
import {
	getData
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/genogramUtils";
import {messageDialog} from "@/core/components/Dialogs/dialog";
import GenogramEdgeLabelManager
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramEdgeLabelManager";
import GenogramSelectionModeController
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramSelectionModeController";
import GenogramMultiSelectHintController
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramMultiSelectHintController";
import GenogramExportWatermarkHelper
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramExportWatermarkHelper";
import GenogramNodeGroupsManager, {
	GROUP_COMMAND
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramNodeGroupsManager";
import GenogramPrimaryPersonOutlineRenderer
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramPrimaryPersonOutlineRenderer";
import GenogramManualConnectionTargetHintRenderer
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramManualConnectionTargetHintRenderer";
import GenogramSexualCommunicationBadgeRenderer
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramSexualCommunicationBadgeRenderer";
import GenogramCursorManager
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramCursorManager";
import {
	isStickyNoteNodeData,
	STICKY_NOTE_TYPE,
	syncStickyNoteNodeData
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramStickyNoteHelper";
import {calculateHandwritingNoteY} from "@/tools/GenogramTool/lib/GenogramHandwritingSpaceHelper";
import {getRenderedGenogramNodeHeight} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramNodeSizeScaleHelper";
import GenogramTiledPngExportManager
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/export/GenogramTiledPngExportManager";
import {
	GenogramConnectionCategoryEnum,
	getGenogramConnectionCategoryByEdgeData,
} from "@shared/Genogram/GenogramConnectionCategoryEnum";
import {
	GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX,
	PDF_TILED_EXPORT_MAX_LONG_SIDE_PX,
	PDF_TILED_EXPORT_MAX_TOTAL_PIXELS,
}
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/export/GenogramExportConstants";
import {
	buildScreenExportLayout,
	drawLegendBorderToCanvas,
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/export/GenogramExportLayoutHelper";

const NO_LISTENER = undefined
const EXPORT_MERGE_MODE = {
	SCREEN: "screen",
}
const CUSTOM_CONNECTION_RENDER_MANAGER_SCRATCH_KEY = "_qwCustomConnectionRenderManager"
const CUSTOM_CONNECTION_RENDER_CONFIG_RESOLVER_SCRATCH_KEY = "_qwCustomConnectionRenderConfigResolver"
const GENOGRAM_FORCE_EXPORT_MODE_QUERY_PARAM = "forceGenogramExportMode"
const GENOGRAM_EXPORT_MODE = {
	FULL: "full",
	TILED: "tiled",
}
const GENOGRAM_DEBUG_TILE_BORDERS_QUERY_PARAM = "debugTileBorders"
const LEGACY_OVERSIZE_EXPORT_WARNING_ENABLED = false
const LOCAL_PNG_EXPORT_MAX_DIMENSION_PX = 8000
const LOCAL_PNG_EXPORT_MAX_TOTAL_PIXELS = 40000000
const STANDARD_PNG_EXPORT_DIAGNOSTIC_PREFIX = `${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} [StandardPng]`
const PDF_EXPORT_DIAGNOSTIC_PREFIX = `${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} [Pdf]`
const OVERLAP_HINT_DRAG_START_POSITION_SCRATCH_KEY = "_qwOverlapHintDragStartPosition"
const OVERLAP_HINT_DRAG_LEARN_DISTANCE_PX = 10

// GenogramRenderer.prototype.register(cytoscape)


class CyEditor extends EventBus {

	genogramItem = null

	constructor(params = defaultEditorConfig, analyticsManager) {
		super()
		this._plugins = {}
		this._listeners = {}
		this.analyticsManager = analyticsManager
		this.exportWatermarkHelper = new GenogramExportWatermarkHelper()
		this.tiledPngExportManager = new GenogramTiledPngExportManager()
		this._init(params)
	}

	_init(params) {
		this._initOptions(params)
		this._registerExtensions()
		this._initDom()
		this._initCy()
		this._initPlugin()
		this._initEvents()

		setTimeout(() => {
			this.invalidateLabelFontSize()
			this.syncLeftPanelNodesByLimit()
		}, 0)
	}

	_registerExtensions(){
		let readOnly = this.cyOptions.readonly
		let rendererOptions = this.cyOptions.renderer
		if(!readOnly){
			cytoscape.use(edgehandles)
		}
		if(this.editorOptions.compoundDnd.isEnabled){
			cytoscape.use(compoundDragAndDrop)
		}
		cytoscape.use(dragAddNodes)
		cytoscape.use(touchDragAddNodes)
		cytoscape.use(edgeConnections);
		cytoscape.use(cytoscapeLayers)
		cytoscape.use(undoRedo)
		cytoscape.use(contextMenu)
		cytoscape.use(nodeContextMenu)
		cytoscape.use(cynavigator)
		cytoscape.use(snapGrid)
cytoscape.use(noderesize)
// cytoscape.use(editElements)
		cytoscape.use(toolbar)
		cytoscape.use(clipboard)
		cytoscape.use(templates)

		cytoscape('renderer', rendererOptions.name, rendererOptions.clazz)

	}

	setGenogramItem(genogramItem) {
		this.genogramItem = genogramItem;
	}

	setupCdnd(){

		let compoundDnd = this.editorOptions.compoundDnd || {}

		if(!compoundDnd.isEnabled){
			return;
		}
		var cdnd = this.cy.compoundDragAndDrop({
			newParentNode: (grabbedNode, dropSibling) => ({
				group: 'nodes',
				data: {
					type: 'compound',
					id: uuidv4()
				},
			}),
		});

		var removeEmptyParents = true;

		var isParentOfOneChild = (node) => {
			let res = node.isParent() && node.children().length === 1;
			// console.log("compoundDnd: isParentOfOneChild: node = ", node, ", res = ", res)
			return res
		};

		var removeParent = (parent) => {
			parent.children().move({ parent: null });
			console.log("compoundDnd: removeParent: parent = ", parent, ", isParent = ", parent.isParent(), ", isParentOfOneChild = ", isParentOfOneChild(parent))
			parent.children().data({ parent: null });
			parent.remove();
		};

		var removeParentsOfOneChild = () => {
			this.cy.nodes().filter(node => isParentOfOneChild(node)).forEach(node => removeParent(node));
		};

		// custom handler to remove parents with only 1 child on drop
		this.cy.on('cdndout', (event, dropTarget) => {
			if( removeEmptyParents && isParentOfOneChild(dropTarget) ){
				removeParent(dropTarget);
			}
		});

		// custom handler to remove parents with only 1 child (on remove of drop target or drop sibling)
		this.cy.on('remove', (event) => {
			if( removeEmptyParents ){
				removeParentsOfOneChild();
			}
		});
	}

	_verifyParams(params) {
		const mustBe = (arr, type) => {
			let valid = true
			arr.forEach(item => {
				const typeItem = typeof params[item]
				if (typeItem !== type) {
					console.warn(`'editor.${item}' must be ${type}`)
					valid = false
				}
			})
			return valid
		}
		const {
			zoomRate,
			toolbar,
			nodeTypes
		} = params
		mustBe(['noderesize', 'dragAddNodes', 'elementsInfo', 'snapGrid', 'navigator', 'useDefaultNodeTypes', 'autoSave'], 'boolean')
		mustBe(['beforeAdd', 'afterAdd'], 'function')

		if (zoomRate <= 0 || zoomRate >= 1 || typeof zoomRate !== 'number') {
			console.warn(`'editor.zoomRate' must be < 1 and > 0`)
		}

		if (typeof toolbar !== 'boolean' && !Array.isArray(toolbar)) {
			console.warn(`'editor.nodeTypes' must be boolean or array`)
		}

		if (!Array.isArray(nodeTypes)) {
			console.warn(`'editor.nodeTypes' must be array`)
		}

	}

	_initOptions(params = {}) {
		this.editorOptions = Object.assign({}, defaultEditorConfig.editor, params.editor)
		let compoundDnd = this.editorOptions.compoundDnd || {}
		let cursorConfig = this.editorOptions.cursorConfig || {}

		this.editorOptions.compoundDnd = {
			...defaultEditorConfig.editor.compoundDnd,
			...compoundDnd
		}
		this.editorOptions.cursorConfig = {
			...defaultEditorConfig.editor.cursorConfig,
			...cursorConfig,
		}

		this._verifyParams(this.editorOptions)
		const {useDefaultNodeTypes, zoomRate} = this.editorOptions
		this._handleOptonsChange = {
			snapGrid: this._snapGridChange,
			lineType: this._lineTypeChange
		}
		if (params.editor && params.editor.nodeTypes && useDefaultNodeTypes) {
			this.setOption('nodeTypes', defaultNodeTypes.concat(params.editor.nodeTypes))
		}
		if (zoomRate <= 0 || zoomRate >= 1) {
			console.error('zoomRate must be float number, greater than 0 and less than 1')
		}
		this.cyOptions = Object.assign({}, defaultEditorConfig.cy, params.cy)

		const {elements} = this.cyOptions
		if (elements) {
			if (Array.isArray(elements.nodes)) {
				elements.nodes.forEach(node => {
					node.data = Object.assign({}, defaultConfData.node, node.data)
				})
			}
			if (Array.isArray(elements.edges)) {
				elements.edges.forEach(edge => {
					edge.data = Object.assign({}, defaultConfData.edge, edge.data)
				})
			}
		}
	}

	_initCy() {
		console.log("this.cyOptions: ", JSON.parse(JSON.stringify(this.cyOptions)))
		this.cyOptions.container = this.cyOptions.container || '#cy'
		console.log("this.cyOptions1: ", JSON.parse(JSON.stringify(this.cyOptions)))
		if (typeof this.cyOptions.container === 'string') {
			console.log("this.cyOptions2: ", this.cyOptions.container)
			this.cyOptions.container = utils.query(this.cyOptions.container)[0]
		}
		console.log("this.cyOptions3: ", JSON.parse(JSON.stringify(this.cyOptions)), ", this.cyOptions.container = ", this.cyOptions.container)
		if (!this.cyOptions.container) {
			console.error('There is no any element matching your container')
			return
		}
		this.cyOptions.renderer = {
			name: "genogramRenderer",
		},

		this.cy = cytoscape(this.cyOptions)
		this.cy.scratch(CUSTOM_CONNECTION_RENDER_MANAGER_SCRATCH_KEY, this.editorOptions.customConnectionRenderManager || null)
		this.cy.scratch(CUSTOM_CONNECTION_RENDER_CONFIG_RESOLVER_SCRATCH_KEY, this.getCustomConnectionRenderConfigByLineSubType.bind(this))

	}

	_initDom() {
		// let {dragAddNodes, navigator, elementsInfo, toolbar, container} = this.editorOptions
		// let left = dragAddNodes ? `<div class="left"></div>` : ''
		// let navigatorDom = navigator ? `<div class="panel-title">导航器</div><div id="thumb"></div>` : ''
		// let infoDom = elementsInfo ? `<div id="info"></div>` : ''
		// let domHtml = toolbar ? '<div id="toolbar"></div>' : 'hey'
		// let right = ''
		// if (navigator || elementsInfo) {
		// 	right = `<div class="right">
        //         ${navigatorDom}
        //         ${infoDom}
        //       </div>`
		// }
		// domHtml += `<div id="editor">
        //         ${left}
        //         <div id="cy"></div>
        //         ${right}
        //       </div>`
		// let editorContianer
		// if (container) {
		// 	if (typeof container === 'string') {
		// 		editorContianer = utils.query(container)[0]
		// 	} else if (utils.isNode(container)) {
		// 		editorContianer = container
		// 	}
		// 	if (!editorContianer) {
		// 		console.error('There is no any element matching your container')
		// 		return
		// 	}
		// } else {
		// 	editorContianer = document.createElement('div')
		// 	editorContianer.className = 'cy-editor-container'
		// 	document.body.appendChild(editorContianer)
		// }
		// editorContianer.innerHTML = domHtml
	}

	_initEvents() {
		const {editElements, edgehandles, noderesize, undoRedo} = this._plugins

		this._listeners.handleDocumentKeyDown = event => {
			if(event.key !== "Escape"){
				return
			}

			this.cancelPlacementMode()
		}

		this._listeners.showElementInfo = () => {
			if (editElements) {
				editElements.showElementsInfo()
			}
		}
		this._listeners.syncNodeDependentLayoutAfterResize = (e, node) => {
			this.syncNodeDependentLayoutAfterRender(e, node)
		}

		this._listeners.handleCommand = this._handleCommand.bind(this)

		this.keyActionListener = new KeyActionListener((command, event) => {
			let commandItem = findCyEditorCommand(command) || {command}
			this._listeners.handleCommand(event, {
				...commandItem,
				context: "Genogram Keyboard Shortcut used",
			})
		})
		document.addEventListener('keydown', this._listeners.handleDocumentKeyDown)


		this._listeners.hoverout = (e) => {
			if (edgehandles) {
				edgehandles.active = true
				edgehandles.stop(e)
			}
			if (noderesize) {
				noderesize.clearDraws()
			}
		}

		this._listeners.select = (e) => {
			if (this._doAction === 'select') return
			// if (undoRedo) {
			// 	this._undoRedoAction('select', e.target)
			// }
		}
		this._listeners.unselect = (e) => {
			// if (this._doAction === 'select') return
			// if (undoRedo) {
			// 	this._undoRedoAction('unselect', e.target)
			// }
		}

		this._listeners.addNodeStart = (evt, params = {}) => {

			if(window.screen.width < 768){
				// this.toggleLeftPanel()
			}
			if(params.triggerType === "click"){
				this.startPlacementMode(params.shape, params.sourceEvent)
				let itemName = this.formatTapToAddItemName(params.shape)
				let itemType = this.formatTapToAddItemType(params.shape)
				if(itemName){
					this.emit("onboardingTapAddRequested", this, {
						itemName,
						itemType,
					})
				}
			}

		}
		this._listeners.addNodePlaceAttempt = (evt, params = {}) => {
			if(params.triggerType === "click" || params.triggerType === "touchstart"){
				this.stopPlacementMode()
				this.emit("onboardingTapAddPlacementAttempted", this, {
					triggerType: params.triggerType,
				})
			}
		}

		this._listeners.addEles = async (evt, el) => {
			console.log("addEles22: ", el)
			if (el.position) {
				let panZoom = {pan: this.cy.pan(), zoom: this.cy.zoom()}
				let x = (el.position.x - panZoom.pan.x) / panZoom.zoom
				let y = (el.position.y - panZoom.pan.y) / panZoom.zoom
				el.position = {x, y}
			}
			let droppedNodeId = this.getDroppedNodeContextMenuTargetId(el)
			let isAddedFromDragAddNodes = !!el?.scratch?.addedFromDragAddNodes
			let addedNodeType = el?.data?.type || ""
			console.log("addEles22: el.data.type = ", el.data.type)
			if(this._plugins.templates && el.data.type && el.data.type.startsWith("template")){
				el = await this._plugins.templates.fromTemplateToElements(el)
			}

			// if(!this.ensureNewElementsFitMaxArea(el)){
			// 	await this.notifyAction("showMessage", {
			// 		title: "Genogram is too wide",
			// 		message: `This genogram is too wide and it wont export. Please place the nodes closer to each other.`,
			// 	})
			// 	this.fit()
			// 	return
			// }
			this.addElements(el)
			this.showNodeContextMenuForNodeId(droppedNodeId)
			if(isAddedFromDragAddNodes){
				this.emit("onboardingDragAddCompleted", this, {
					type: addedNodeType,
				})
			}

		}



		this.cy.on('zoom', (event) => {
			this.invalidateLabelFontSize()
		})

		this.cy.on("cyeditor.data", e => {
			this.syncEdgeLabels()
			this.invalidateLabelFontSize()
		})


		this.cy.on('nodeKeyChanged', (event, {ele, nodeKey, callback}) =>{
			let {type, tags, isPassedAway, isPrimaryPerson} = ele.data()
			nodeKey = "" + nodeKey
			if(type){
				nodeKey += `_type_${type}`
			}
			if(tags){
				let maxTagsToCalculate = 3
				nodeKey = nodeKey + '_' + Math.min(tags.length, maxTagsToCalculate) + "_" + tags.filter((item, index) => index < maxTagsToCalculate).map(tag => tag.color).join('_')
			}
			if(isPassedAway){
				nodeKey += '_pa'
			}
			if(isPrimaryPerson){
				nodeKey += '_pp'
			}

			// console.log("nodeKeyChanged 2.2: ", nodeKey, ", tags = ", tags)
			callback(nodeKey)
		})

		this.cy.on('cyeditor.added cyeditor.remove cyeditor.data cyeditor.paste cyeditor.linetype afterDragfree cyeditor.undo cyeditor.redo', e => {
			console.log("genogram changed: on change should trigger: ", e)
			this.syncEdgeLabels()
			this.syncNodeGroups()
			this.emit('change', e.target, this)
		})

		this.cy.on('boxselect', e => {
			console.log("genogram changed: boxselected: ", e)
			let command = "boxselect"
			let commandOpt = this._plugins.toolbar._options.commands.find(it => it.command === command)
			if(this.selectionModeController?.shouldKeepSelectionModeAfterBoxSelect()){
				return
			}
			//deselect boxselect so use can pan after the first selection
			console.log("genogram changed: boxselected: commandOpt = ", commandOpt)
			if(commandOpt.selected){
				this._plugins.toolbar.rerender(command, { selected: false })
				console.log("genogram changed: boxselected2: commandOpt = ", commandOpt)
				this.cy.trigger('cyeditor.toolbar-command', commandOpt)
			}
		})



		this._listeners._changeUndoRedo = this._changeUndoRedo.bind(this)
		this._listeners.handleNodeAddedForOverlapHint = this.handleNodeAddedForOverlapHint.bind(this)
		this._listeners.handleNodeDragLifecycleForOverlapHint = this.handleNodeDragLifecycleForOverlapHint.bind(this)

		this.cy.on('cyeditor.noderesize-resized cyeditor.noderesize-resizing', this._listeners.showElementInfo)
			.on('cyeditor.noderesize-resized', this._listeners.syncNodeDependentLayoutAfterResize)
			.on('cyeditor.toolbar-command', this._listeners.handleCommand)
			// .on('click', this._listeners.hoverout)
			.on('select', this._listeners.select)
			// .on('unselect', this._listeners.unselect)
			.on('cyeditor.addnode', this._listeners.addEles)
			.on('cyeditor.addnodeplaceattempt', this._listeners.addNodePlaceAttempt)
			.on('cyeditor.afterDo cyeditor.afterRedo cyeditor.afterUndo', this._listeners._changeUndoRedo)
			.on('cyeditor.addnodestart', this._listeners.addNodeStart)

		this.cy.on('add', 'node', this._listeners.handleNodeAddedForOverlapHint)
		this.cy.on('grab dragfree', 'node', this._listeners.handleNodeDragLifecycleForOverlapHint)


		this.cy.on('ehcomplete', async (event, sourceNode, targetNode, addedEdge) => {
			this._plugins.nodeContextMenu?.suppressNextNodeTap?.(targetNode)
			let selected = this.cy.$(':selected')
			selected.every(item => item.unselect())
			console.log("addedEdge: ", addedEdge)
			if (addedEdge && addedEdge.length > 0) {
				addedEdge[0].select()
			}
			this.cy.trigger('cyeditor.added')
			await this.tryShowManualConnectionLinePicker(addedEdge)
		});

			this.cy.on('ehstop ehcancel', () => {
				this.syncNodeContextMenuAvailability()
			})

			this.cy.on('select unselect remove', () => {
				this.syncNodeContextMenuAvailability()
				this.syncNodeContextMenuSelectionState()
			})

		this.cy.on('cyeditor.nodeContextMenuAction', (event, payload) => {
			this.handleNodeContextMenuAction(payload)
		})


		this.cy.on('add grab drag dragfree', 'node', async e => {
			let node = e.target
			// console.log("drag dragfree node = ", node)
			// console.log("dragNode: e = ", e)

			if (node.data().isAuxNode) {
				await this.handleAuxNodeDrag(e, node)
				return
			}
			if (node.data().isHandwritingSpaceNote) {
				return
			}

			this.syncNodeDependentLayout(e, node)

			if(e.type === "dragfree"){
				await this.multiSelectHintController.onNodeDragFree(node.id())
				this.cy.trigger('afterDragfree')
			}
		})


		this.cy.on('cyeditor.added', e => {
			console.log("add node", e)
			this.syncLeftPanelNodesByLimit()
		})


		this.cy.on('remove', 'node', e => {
			console.log("remove node", e)
			let node = e.target
			console.log("remove node: removedItems = ", node, ", data = ", node.data())
			if(node){
				console.log("remove node: hasCoreSelf0")
				let targetData = node.data()
				if (targetData && targetData.isAuxNode) {
					this.onAuxNodeRemoved(e.target)
				}
				this.syncLeftPanelNodesByLimit()
			}
		})

		this.cy.on('remove', 'edge', e => {
			console.log("remove edge", e)
			this.onEdgeRemoved(e.target)
		})

		this.cy.on('afterLineTypeChange', (e, targetsParam = []) => {
			let targets = [...targetsParam]
			if(e.target.length){
				targets.push(e.target)
			}
			console.log("targets = ", targets)
			for(let target of targets){
				if(!target.isEdge() || getGenogramConnectionCategoryByEdgeData(target.data(), null) === GenogramConnectionCategoryEnum.SOCIAL){
					return
				}
				this.removeAuxNodesForParentEdge(target)

			}
		})

		this.emit('ready')
	}

	ensureNewElementsFitMaxArea(elements){
		elements = ensureArray(elements)
		let maxArea = this.editorOptions.maxArea || {width: 20000, height: 20000}
		let boundingBox = this.cy.elements().boundingBox();

		console.log("ensureNewElementsFitMaxArea: boundingBox = ", boundingBox, ", maxArea = ", maxArea, ", elements = ", elements)

		for(let el of elements){
			if(el.position){
				let {x, y} = el.position
				if(x < boundingBox.x1) boundingBox.x1 = x
				if(x > boundingBox.x2) boundingBox.x2 = x
				if(y < boundingBox.y1) boundingBox.y1 = y
				if(y > boundingBox.y2) boundingBox.y2 = y
			}

		}
		console.log("ensureNewElementsFitMaxArea: boundingBox2 = ", boundingBox, ", maxArea = ", maxArea, ", elements = ", elements)

		let w = boundingBox.x2 - boundingBox.x1
		let h = boundingBox.y2 - boundingBox.y1
		let fits = w <= maxArea.width && h <= maxArea.height
		return fits
	}

	async addKids(initialNode){
		if(this.cyOptions.readonly){
			return
		}
		if(this._plugins.templates){
			let res = await this._plugins.templates.addKids(initialNode)
			if(!res){
				return
			}
			let {newElements, partners, marriageEdge } = res
			this.addElements(newElements)
			this.selectAllKidsAndCouple(partners, marriageEdge)
		}

	}

	async addPartner(initialNode){
		if(this.cyOptions.readonly){
			return
		}
		if(this._plugins.templates){
			let res = await this._plugins.templates.addPartner(initialNode)
			if(!res){
				return
			}
			let {newElements} = res
			this.addElements(newElements)
			this.selectAddedNodes(newElements)
		}
	}

	async addParents(initialNode){
		if(this.cyOptions.readonly){
			return
		}
		if(this._plugins.templates){
			let elems = await this._plugins.templates.addParents(initialNode)
			if(!elems){
				return
			}
			this.addElements(elems)
			initialNode.select()
		}
	}

	async addSiblings(initialNode){
		if(this.cyOptions.readonly){
			return
		}
		if(this._plugins.templates){
			let res = await this._plugins.templates.addSiblings(initialNode)
			if(!res){
				return
			}
			let {newElements, partners, marriageEdge } = res
			this.addElements(newElements)
			this.selectAllKidsAndCouple(partners, marriageEdge)
			initialNode.select()
		}
	}

	selectAllKidsAndCouple(partners, marriageEdge){


		let auxNodes = getData(marriageEdge).auxNodes || []
		console.log("selectAllKidsAndCouple: auxNodes = ", auxNodes, ", marriageEdge = ", marriageEdge)

		for(let auxNodeId of auxNodes){
			let kidsArray = this.cy.nodes().filter(node => {
				let {auxNodes} = node.data() || {}
				// console.log("selectAllKidsAndCouple: node = ", node, ", auxNodes = ", auxNodes)

				return Array.isArray(auxNodes) && auxNodes.includes(auxNodeId)
			})
			// console.log("selectAllKidsAndCouple: kidsArray = ", kidsArray)
			// allKids.push(...kidsArray)
			kidsArray.select()
		}


		let partnersSelector = partners.map(partner => `[id="${getData(partner).id}"]`).join(", ")
		partners = this.cy.filter(partnersSelector)

		console.log("selectAllKidsAndCouple: partners = ", partners)

		partners.select()
	}

	selectAddedNodes(elements){
		let nodeIds = asArray(elements)
			.filter(item => item?.group === "nodes" && item?.data?.id)
			.map(item => item.data.id)
		if(!nodeIds.length){
			return
		}

		let selector = nodeIds.map(id => `[id="${id}"]`).join(", ")
		this.unselectAll()
		this.cy.filter(selector).select()
	}

	addElements(el) {
		if(!el){
			return
		}
		this.setElementsDefaults(el)
		console.log("addElements: el = ", el)
		el.firstTime = true
		if (!this._hook('beforeAdd', el, true)) return
		if (undoRedo) {
			this._undoRedoAction('add', el)
		} else {
			this.cy.add(el)
		}
		let ids = asArray(el).map(it => it.data.id)
		let selector = ids.map(id => `[id="${id}"]`).join(", ")
		if(this.nodeGroupsManager?.isGroupingModeActive){
			this.nodeGroupsManager.reapplyDraftSelection()
		} else {
			this.unselectAll()
			this.cy.filter(selector).select()
		}
		this._hook('afterAdd', el)
		this.cy.trigger('cyeditor.added')
		this.invalidateLabelFontSize()
	}

	handleNodeAddedForOverlapHint(event) {
		let node = event.target
		if(!this.isEligibleNodeForOverlapHint(node)){
			return
		}

		if(!this.pendingOverlapHintNodeIds){
			this.pendingOverlapHintNodeIds = new Set()
		}
		this.pendingOverlapHintNodeIds.add(node.id())
		this.scheduleOverlapHintCheck()
	}

	handleNodeDragLifecycleForOverlapHint(event) {
		let node = event.target
		if(!this.isEligibleNodeForOverlapHint(node)){
			return
		}

		if(event.type === "grab"){
			this.captureOverlapHintDragStart(node)
			return
		}

		if(event.type === "dragfree"){
			if(this.hasNodeMovedEnoughForOverlapHint(node)){
				this.emit("nodeDragLearnedForOverlapHint", this, {
					nodeId: node.id(),
				})
			}
			this.clearOverlapHintDragStart(node)
		}
	}

	isEligibleNodeForOverlapHint(node) {
		let nodeData = node?.data?.()
		return !!nodeData && !nodeData.isAuxNode
	}

	scheduleOverlapHintCheck() {
		if(this.pendingOverlapHintTimerId){
			return
		}

		this.pendingOverlapHintTimerId = setTimeout(() => {
			this.pendingOverlapHintTimerId = null
			this.flushOverlapHintCheck()
		}, 0)
	}

	flushOverlapHintCheck() {
		let nodeIds = Array.from(this.pendingOverlapHintNodeIds || [])
		this.pendingOverlapHintNodeIds?.clear?.()
		if(!nodeIds.length){
			return
		}

		let addedNodes = nodeIds
			.map(nodeId => this.cy.getElementById(nodeId))
			.filter(node => node?.nonempty?.() && this.isEligibleNodeForOverlapHint(node))
		if(!addedNodes.length){
			return
		}

		let hasOverlap = addedNodes.some(node => this.doesNodeOverlapEligibleNode(node))
		if(!hasOverlap){
			return
		}

		this.emit("nodeAddOverlapDetected", this)
	}

	doesNodeOverlapEligibleNode(node) {
		let otherNodes = this.cy.nodes().filter(nodeLocal => {
			return nodeLocal.id() !== node.id() && this.isEligibleNodeForOverlapHint(nodeLocal)
		})
		let nodeBox = this.getOverlapHintNodeBoundingBox(node)
		let hasOverlap = false
		otherNodes.forEach(nodeLocal => {
			if(hasOverlap){
				return
			}

			let otherBox = this.getOverlapHintNodeBoundingBox(nodeLocal)
			if(this.areOverlapHintBoundingBoxesOverlapping(nodeBox, otherBox)){
				hasOverlap = true
			}
		})
		return hasOverlap
	}

	getOverlapHintNodeBoundingBox(node) {
		return node.boundingBox({
			includeLabels: false,
			includeOverlays: false,
		})
	}

	areOverlapHintBoundingBoxesOverlapping(leftBox, rightBox) {
		let isOverlapping = false
		if(leftBox.x1 < rightBox.x2 && leftBox.x2 > rightBox.x1 && leftBox.y1 < rightBox.y2 && leftBox.y2 > rightBox.y1){
			isOverlapping = true
		}
		return isOverlapping
	}

	captureOverlapHintDragStart(node) {
		let position = node?.position?.()
		if(!position){
			return
		}

		node.scratch(OVERLAP_HINT_DRAG_START_POSITION_SCRATCH_KEY, {
			x: position.x,
			y: position.y,
		})
	}

	hasNodeMovedEnoughForOverlapHint(node) {
		let startPosition = node.scratch(OVERLAP_HINT_DRAG_START_POSITION_SCRATCH_KEY)
		let currentPosition = node.position()
		let hasMoved = false
		if(startPosition && currentPosition){
			let xDiff = currentPosition.x - startPosition.x
			let yDiff = currentPosition.y - startPosition.y
			let distance = Math.sqrt(xDiff * xDiff + yDiff * yDiff)
			if(distance >= OVERLAP_HINT_DRAG_LEARN_DISTANCE_PX){
				hasMoved = true
			}
		}
		return hasMoved
	}

	clearOverlapHintDragStart(node) {
		if(!node?.scratch){
			return
		}

		node.scratch(OVERLAP_HINT_DRAG_START_POSITION_SCRATCH_KEY, null)
	}

	getDroppedNodeContextMenuTargetId(el) {
		let nodeId = null
		let isSingleNode = el?.group === "nodes"
		let isTemplateNode = Boolean(el?.data?.type?.startsWith?.("template"))
		if(isSingleNode && !isTemplateNode){
			nodeId = el.data.id
		}
		return nodeId
	}

	showNodeContextMenuForNodeId(nodeId) {
		if(!nodeId){
			return
		}
		setTimeout(() => {
			let node = this.cy.getElementById(nodeId)
			if(!node?.nonempty?.()){
				return
			}
			this._plugins.nodeContextMenu?.showForNode?.(node)
			}, 0)
	}

	isNodeEligibleForContextMenu(node) {
		if(this.cyOptions.readonly){
			return false
		}
		if(!node?.nonempty?.()){
			return false
		}

		let nodeData = node.data()
		return !nodeData.isAuxNode && !isStickyNoteNodeData(nodeData)
	}

	setElementsDefaults(elements) {
		try{
			elements = ensureArray(elements)
			for(let elem of elements){
				if(!elem.group || elem.group === 'nodes'){
					if(this.genogramItem){
						elem.data.hideNote = this.genogramItem.hideNoteDefault;
						this.genogramItem.updateNodeLabel(elem.data)
					}
				}
			}
		} catch (error){
			console.error(error)
		}
	}

	addOrUpdateElements(elArray) {
		if(!elArray){
			return
		}
		let updateData = []
		let newElems = []
		for(let el of elArray){
			let elemId = getData(el).id
			let existingElem = this.cy.getElementById(elemId)
			if(existingElem.length === 0){
				newElems.push(el)
			} else {
				updateData.push({element: existingElem, data: getData(el)})
			}
		}

		console.log("addOrUpdateElements: newElems = ", newElems, ", updateData = ", updateData, ", elArray = ", elArray)
		if(newElems.length > 0){
			this.addElements(newElems)
		}
		if(updateData.length > 0){
			this.updateElements(updateData)
		}
	}

	updateElements(updateData) {
		//updateData is {element, data} or [{element, data}]
		this._undoRedoAction('dataChange', updateData)
	}

	trySyncAuxNodesForParentEdge(e, node){
		let connectedEdges = node.connectedEdges()

		for(let edge of connectedEdges){
			if (getGenogramConnectionCategoryByEdgeData(edge.data(), null) === GenogramConnectionCategoryEnum.SOCIAL) {

				let auxNodes = edge.data().auxNodes || []
				// console.log("position edge auxNodeIds = ", auxNodeIds)
				for (let auxNodeId of auxNodes) {
					let auxNode = this.cy.getElementById(auxNodeId)
					if(auxNode && auxNode.length > 0){
						this.forcePositionAuxNode(auxNode)
					}
				}
				// this.auxNodeForceFollowParentEdge(e, edge)
			}
		}
	}

	syncNodeDependentLayout(e, node){
		if(!node?.nonempty?.()){
			return
		}
		let nodeData = node.data()
		if(nodeData.isAuxNode || nodeData.isHandwritingSpaceNote){
			return
		}

		this.auxNodeForceFollowChild(e, node)
		this.syncHandwritingNoteForParentNode(node)
		this.trySyncAuxNodesForParentEdge(e, node)
	}

	syncNodeDependentLayoutAfterRender(e, node){
		this.syncNodeDependentLayout(e, node)
		setTimeout(() => this.syncNodeDependentLayout(e, node), 0)
	}

	async handleAuxNodeDrag(e, node){
		if(e.type === "add"){
			let edge = this.cy.getElementById(node.data().parentEdgeId)
			if(!edge.segmentPoints()){
				await delay(0)//Workaround. edge.segmentPoints() is not available immediately when the full genogram is added for the first time.
			}
		}
		if(e.type === "dragfree"){
			this._plugins.cySnapToGrid.snapNode(node)
		}
		this.auxNodeForceSnapX(node)

	}

	auxNodeForceFollowChild(e, node){
		let auxNodes = node.neighborhood().nodes().filter(node => node.data().isAuxNode)
		if(auxNodes.length === 0){
			return
		}


		auxNodes.forEach(nodeLocal => {
			this.forcePositionAuxNode(nodeLocal)
		})

		// switch (e.type){
		// 	case "grab":
		// 		console.log("auxNodeForceFollowChild: grab, auxNodes = ", auxNodes)
		// 		allNodes.forEach(nodeLocal => nodeLocal.scratch({
		// 			grabNodePosition: Object.assign({}, nodeLocal.position()),
		// 		}))
		// 		break
		// 	case "drag": {
		// 		// console.log("auxNodeForceFollowChild: drag, node.scratch() = ", node.scratch(), ", e.position = ", e.position, ", e = ", e)
		// 		let xDiff = node.position().x - node.scratch().grabNodePosition.x
		// 		let yDiff = node.position().y - node.scratch().grabNodePosition.y
		// 		auxNodes.forEach(nodeLocal => {
		// 			let scratch = nodeLocal.scratch()
		// 			if (scratch && scratch.grabNodePosition) {
		// 				let targetX
		// 				let neighbourNodes = nodeLocal.neighborhood().nodes();
		// 				if(neighbourNodes.length > 1) {
		// 					let averageX = neighbourNodes.reduce((acc, node) => acc + node.position().x, 0) / neighbourNodes.length
		// 					// targetX = scratch.grabNodePosition.x + xDiff
		// 					targetX = averageX
		// 					nodeLocal.scratch({snapToGrid: false})
		// 				} else {
		// 					targetX = node.position().x
		// 					nodeLocal.scratch({snapToGrid: true})
		// 				}
		// 				this.auxNodeForceSnapX(nodeLocal, targetX)
		// 			}
		// 		})
		// 	}
		// 		break
		// 	case "dragfree":
		// 		// console.log("auxNodeForceFollowChild: dragfree")
		// 		allNodes.forEach(node => {
		// 			let {snapToGrid} = node.scratch()
		// 			if(snapToGrid !== false){
		// 				this._plugins.cySnapToGrid.snapNode(node)
		// 			}
		// 			node.scratch({
		// 				grabNodePosition: null,
		// 				grabPointerPosition: null,
		// 				snapToGrid: null,
		// 			})
		// 		})
		// 		break
		// }
		// console.log("dragNodeAux: node = ", node, ", scratch.grabNodePosition = ", node.scratch().grabNodePosition)

	}

	forcePositionAuxNode(auxNode){
		let targetX
		let neighbourNodes = auxNode.neighborhood().nodes();
		if(neighbourNodes.length > 1) {
			let averageX = neighbourNodes.reduce((acc, node) => acc + node.position().x, 0) / neighbourNodes.length
			targetX = averageX
			auxNode.scratch({snapToGrid: false})
		} else if (neighbourNodes.length === 1){
			targetX = neighbourNodes[0].position().x
			auxNode.scratch({snapToGrid: true})
		}
		this.auxNodeForceSnapX(auxNode, targetX)
	}

	syncHandwritingNoteForParentNode(node){
		let noteNode = this.cy.nodes().filter(nodeLocal => {
			let nodeData = nodeLocal.data()
			return nodeData.isHandwritingSpaceNote && nodeData.parentNodeId === node.id()
		})
		if(noteNode.length === 0){
			return
		}

		let nodePosition = node.position()
		let nodeHeight = getRenderedGenogramNodeHeight(node.data())
		let noteHeight = Number(noteNode.data("height")) || 0
		noteNode.position({
			x: nodePosition.x,
			y: calculateHandwritingNoteY(nodePosition.y, nodeHeight, noteHeight),
		})
	}

	auxNodeForceFollowParentEdge(e, edge){
		if(!edge.segmentPoints()){
			console.warn("auxNodeForceFollowParentEdge: edge.segmentPoints() is not available")
			return;
		}
		let [pt1, pt2] = edge.segmentPoints()
		let x1 = pt1.x
		let y1 = pt1.y
		let x2 = pt2.x
		let y2 = pt2.y
		let targetY = y1
		let auxNodes = edge.data().auxNodes || []
		// console.log("position edge auxNodeIds = ", auxNodeIds)
		for (let auxNodeId of auxNodes) {
			let auxNode = this.cy.getElementById(auxNodeId)
			// console.log("auxNode = ", auxNode)
			if(auxNode.length === 0){
				return;
			}

			let {x, y} = auxNode.position()

			if(x < x1 || x > x2){
				x = Math.min(x2, Math.max(x1, x))

			}
			auxNode.position({x, y: targetY})

			if(e.type === "dragfree") {
				this._plugins.cySnapToGrid.snapNode(auxNode)
			}

		}
	}

	auxNodeForceSnapX(node, targetX){
		let edge = this.cy.getElementById(node.data().parentEdgeId)
		if(edge.length === 0){
			this.cy.remove(node)
			return;
		}

		if(!edge.segmentPoints()){
			return;
		}
		let [pt1, pt2] = edge.segmentPoints()
		let x1 = pt1.x
		let y1 = pt1.y
		let x2 = pt2.x
		let snappedX = targetX || node.position().x
		snappedX = Math.min(x2, Math.max(x1, snappedX))
		let xPositionPercent = (snappedX - x1) / (x2 - x1)
		let newPosition = {
			x: snappedX,
			y: y1
		}
		node.position(newPosition)
	}

	syncLeftPanelNodesByLimit(){
		if(!this._plugins.dragAddNodes) {
			return
		}

		let nodesWithLimit = this.cy.nodes().filter(x => x.data().instanceLimit !== undefined)
		let typeToCount = {}
		nodesWithLimit.forEach(node => {
			let type = node.data().type
			if(!typeToCount[type]){
				typeToCount[type] = 0
			}
			typeToCount[type]++
		})

		let nodeTypes = this._plugins.dragAddNodes._options.nodeTypes
		for(let nodeType of nodeTypes){
			let {type, instanceLimit, data} = nodeType
			instanceLimit = instanceLimit || (data || {}).instanceLimit
			if(instanceLimit === undefined){
				continue
			}
			let count = typeToCount[type] || 0
			nodeType.isExcluded = count >= instanceLimit
			let nodeElemArray = this._plugins.dragAddNodes._shapePanel.querySelectorAll(`[data-type='${type}']`)
			for(let nodeElem of nodeElemArray){
				//set display style to none or visible
				nodeElem.style.display = nodeType.isExcluded ? 'none' : 'block'
			}
		}
	}

	removeAuxNodesForParentEdge(edge){
		let auxNodes = edge.data().auxNodes || []

		console.log("removeAuxNodesForParentEdge: auxNodes = ", auxNodes)

		auxNodes.forEach(nodeId =>{
			let auxNode = this.cy.getElementById(nodeId)
			this.cy.remove(auxNode)
		})
	}
	onEdgeRemoved(edge){
		if(!edge) {
			return
		}
		let targetData = edge.data()
		console.log("onEdgeRemoved: ", targetData)
		console.log("this.cy._private.map: ", this.cy._private.map)
		if(targetData){

			let nodes = [
				this.cy.getElementById(targetData.source),
				this.cy.getElementById(targetData.target),
			]
			console.log("onEdgeRemoved: nodes = ", nodes)
			this.removeAuxNodeIfNoEdges(nodes)
			this.removeAuxNodesForParentEdge(edge)
		}
	}

	unselectAll(){
		this.cy.$(':selected').unselect()
	}

	formatTapToAddItemName(shape = {}) {
		let itemName = shape?.label || shape?.name || ""
		itemName = String(itemName || "").replaceAll("<br/>", " ").trim()
		return itemName
	}
	formatTapToAddItemType(shape = {}) {
		let itemType = "symbol"
		if(shape?.type?.startsWith?.("template")){
			itemType = "template"
		}
		return itemType
	}

	startPlacementMode(shape, sourceEvent = null) {
		this.cursorManager?.startPlacementMode(shape, sourceEvent)
	}

	stopPlacementMode() {
		this.cursorManager?.stopPlacementMode()
	}

	cancelPlacementMode() {
		if(!this.cursorManager?.isPlacementModeActive){
			return
		}

		this.stopPlacementMode()
		this.cy.trigger('cyeditor.cancelnodeplacement')
		this.emit("onboardingTapAddCancelled", this)
	}

	selectAll(){
		this.cy.$().select()
	}

	_initPlugin() {
		const {
			templates, dragAddNodes, elementsInfo, toolbar,
			contextMenu, snapGrid, navigator, noderesize,
			hideSaveButton, nodeContextMenu
		} = this.editorOptions
		let hasStickyNoteType = this.editorOptions.nodeTypes.some(nodeType => nodeType.type === STICKY_NOTE_TYPE)
		// edge
		this.setupCdnd()
		if(this.cy.edgehandles){
			this._plugins.edgehandles = this.cy.edgehandles({
				snap: false,
				showHandleOnHover: false,
				handlePosition() {
					return 'middle middle'
				},
				handleNodes: (node) => {
					console.log("edgeHandleEnabled: ", node)
					let nodeData = node.data()
					return !nodeData.isAuxNode && !isStickyNoteNodeData(nodeData)
				},
				manualConnectionWarning: async params => {
					await this.notifyAction("showToastWarning", params)
				},
				edgeParams: this._edgeParams.bind(this),
			})
		}


		// drag node add to cy
		if (dragAddNodes) {
			this._plugins.dragAddNodes = this.cy.dragAddNodes({
				readonly: this.cyOptions.readonly,
				container: this.cyOptions.containerSelectorLeft || '.left',
				nodeTypes: this.editorOptions.nodeTypes
			})
		}

		if(templates){
			this._plugins.templates = this.cy.templates({
				nodeTypes: this.editorOptions.nodeTypes,
				notifyAction: this.notifyAction.bind(this),
			})
		}

		this.cursorManager = new GenogramCursorManager({
			cy: this.cy,
			editorOptions: this.editorOptions,
		})
		this.cursorManager.init()

		// edit panel
		if (elementsInfo) {
			this._plugins.editElements = this.cy.editElements({
				container: '#info'
			})
		}

		// toolbar
		console.log("toolbar = ", toolbar, ", hideSaveButton = ", hideSaveButton)
		if (Array.isArray(toolbar) || toolbar === true) {
			this._plugins.toolbar = this.cy.toolbar({
				container: this.cyOptions.containerSelectorToolbar || '.cy-toolbar',
				toolbar: toolbar
			})
			if (toolbar === true || toolbar.indexOf('gridon') > -1) {
				this.setOption('snapGrid', true)
			}
			if(hideSaveButton){
				this._plugins.toolbar.removeCommand("save")
				this._plugins.toolbar.removeCommand("savePng")
				this._plugins.toolbar.removeCommand("savePdf")
			}

		}
		this.selectionModeController = new GenogramSelectionModeController({
			cy: this.cy,
			toolbar: this._plugins.toolbar,
			onSelectionModeChanged: isEnabled => {
				if(isEnabled){
					this.multiSelectHintController?.dismissPermanently()
				}
				if(isEnabled){
					this._plugins.noderesize?.disable()
					return
				}
				if(!this.nodeGroupsManager?.isGroupingModeActive){
					this._plugins.noderesize?.enable()
				}
			},
		})
		this.multiSelectHintController = new GenogramMultiSelectHintController({
			isSelectionModeEnabled: () => this.selectionModeController.isBoxSelectionEnabled(),
			notifyHint: async params => await this.notifyAction("showToastInfo", params),
		})
		this.nodeGroupsManager = new GenogramNodeGroupsManager({
			cy: this.cy,
			toolbar: this._plugins.toolbar,
			getGenogramItem: () => this.genogramItem,
			requestGroupsChange: (groups, options = {}) => this.requestNodeGroupsChange(groups, options),
			disableNodeResize: () => {
				this._plugins.noderesize?.disable()
			},
			enableNodeResize: () => {
				if(!this.selectionModeController?.isBoxSelectionEnabled()){
					this._plugins.noderesize?.enable()
				}
			},
			disableNodeContextMenu: () => {
				this._plugins.nodeContextMenu?.disable()
			},
			enableNodeContextMenu: () => {
				this.syncNodeContextMenuAvailability()
			},
			onStateChanged: state => {
				this.emit("groupingModeChanged", this, state)
			},
			onGroupsChanged: groups => {
				this.emit("groupingGroupsChanged", this, groups)
				this.cy.trigger("cyeditor.data")
			},
		})
		this.primaryPersonOutlineRenderer = new GenogramPrimaryPersonOutlineRenderer({
			cy: this.cy,
		})
		this.sexualCommunicationBadgeRenderer = new GenogramSexualCommunicationBadgeRenderer({
			cy: this.cy,
		})
		this.manualConnectionTargetHintRenderer = new GenogramManualConnectionTargetHintRenderer({
			cy: this.cy,
		})

		let needUndoRedo = toolbar === true
		let needClipboard = toolbar === true
		if (Array.isArray(toolbar)) {
			needUndoRedo = toolbar.indexOf('undo') > -1 ||
				toolbar.indexOf('redo') > -1
			needClipboard = toolbar.indexOf('copy') > -1 ||
				toolbar.indexOf('paset') > -1
		}

		// clipboard
		if (needClipboard) {
			this._plugins.clipboard = this.cy.clipboard()
		}
		// undo-redo
		if (needUndoRedo) {
			this._plugins.undoRedo = this.cy.undoRedo()
			this.undoRedoRegisterCustomActions(this._plugins.undoRedo)
		}

		// snap-grid
		if (snapGrid) {
			this._plugins.cySnapToGrid = this.cy.snapToGrid({
				// gridSpacing: 200
			})
		}

		// navigator
		if (navigator) {
			this.cy.navigator({
				container: '#thumb'
			})
		}

		// noderesize
		if (!this.cyOptions.readonly && (noderesize || hasStickyNoteType)) {
			this._plugins.noderesize = this.cy.noderesize({
				selector: `node[type="${STICKY_NOTE_TYPE}"]`,
				triangleSize: 16,
				triangleHitPadding: 14,
				padding: 8,
				transformDimensions: (node, dimensions) => {
					if(!isStickyNoteNodeData(node.data())){
						return dimensions
					}

					let nodeData = {
						...node.data(),
						width: dimensions.width
					}
					syncStickyNoteNodeData(nodeData)
					return {
						...dimensions,
						width: nodeData.width,
						height: nodeData.height
					}
				}
			})
		}

		// context-menu
		if (contextMenu) {
			this._plugins.contextMenu = this.cy.contextMenu()
		}

			if (nodeContextMenu?.enabled && this.cy.nodeContextMenu) {
				let nodeContextMenuOptions = {
					...nodeContextMenu,
					nodeFilter: nodeContextMenu.nodeFilter || ((node) => this.isNodeEligibleForContextMenu(node))
				}
				this._plugins.nodeContextMenu = this.cy.nodeContextMenu(nodeContextMenuOptions)
			}
		}

	async handleNodeContextMenuAction(payload) {
		if(this.cyOptions.readonly){
			return
		}
		let actionId = payload?.action?.id
		let node = payload?.node
		this._plugins.nodeContextMenu?.close()
		if(actionId === "connect"){
			this.startManualConnection(node)
		}
		if(actionId === "addParents"){
			await this.addParents(node)
		}
		if(actionId === "addPartner"){
			await this.addPartner(node)
		}
		if(actionId === "addChildren"){
			await this.addKids(node)
		}
		if(actionId === "addSiblings"){
			await this.addSiblings(node)
		}
	}

	startManualConnection(node) {
		let edgehandles = this._plugins.edgehandles
		if(!edgehandles || !node){
			return
		}
		this._plugins.nodeContextMenu?.disable()
		let manualGesture = edgehandles.startManual(node, node.position())
		if(!manualGesture){
			this._plugins.nodeContextMenu?.enable()
		}
	}

	async tryShowManualConnectionLinePicker(addedElements) {
		let edgehandles = this._plugins.edgehandles
		if(!edgehandles?.lastCompleteWasManual){
			return
		}
		edgehandles.lastCompleteWasManual = false
		let edge = this.getFirstEdgeFromCollection(addedElements)
		if(!edge){
			return
		}
		this.selectOnlyEdge(edge)
		await this.showConnectionTypeDialogForEdge(edge, addedElements, edgehandles)
		edgehandles.lastCompleteTargetWasFamilyEdge = false
	}

	getFirstEdgeFromCollection(elements) {
		let edge = null
		if(elements?.isEdge?.()){
			edge = elements
		} else if(elements?.filter){
			edge = elements.filter(item => item.isEdge())[0] || null
		}
		return edge
	}

	selectOnlyEdge(edge) {
		this.cy.$(':selected').unselect()
		edge.select()
	}

	async showConnectionTypeDialogForEdge(edge, addedElements, edgehandles) {
		let lineTypeItem = await this.notifyAction("showManualConnectionLinePicker", {
			edgeData: edge.data(),
			initialTabName: this.getManualConnectionLinePickerInitialTabName(addedElements, edgehandles),
		})
		if(!lineTypeItem){
			return
		}
		lineTypeItem.setLastUsedNow()
		this.selectOnlyEdge(edge)
		this.setOption('lineType', lineTypeItem)
	}

	getManualConnectionLinePickerInitialTabName(addedElements, edgehandles) {
		let initialTabName = null
		let hasAuxNode = addedElements?.filter?.(item => item.isNode?.() && item.data("isAuxNode"))?.nonempty?.()
		if(edgehandles?.lastCompleteTargetWasFamilyEdge || hasAuxNode){
			initialTabName = "general"
		}
		return initialTabName
	}

	syncNodeContextMenuAvailability() {
		let nodeContextMenu = this._plugins.nodeContextMenu
		if(!nodeContextMenu){
			return
		}
		if(this.shouldEnableNodeContextMenu()){
			nodeContextMenu.enable()
			return
		}
		nodeContextMenu.disable()
	}

	syncNodeContextMenuSelectionState() {
		let nodeContextMenu = this._plugins.nodeContextMenu
		if(!nodeContextMenu){
			return
		}

		let selectedEligibleNodes = this.cy.nodes(":selected")
			.filter(node => this.isNodeEligibleForContextMenu(node))
		if(selectedEligibleNodes.length !== 1){
			nodeContextMenu.close()
			return
		}

		nodeContextMenu.showForNode(selectedEligibleNodes[0])
	}

	shouldEnableNodeContextMenu() {
		if(!this._plugins.nodeContextMenu){
			return false
		}
		if(this.cyOptions.readonly){
			return false
		}
		if(this.nodeGroupsManager?.isGroupingModeActive){
			return false
		}
		let selectedNodeCount = this.cy.nodes(":selected")
			.filter(node => this.isNodeEligibleForContextMenu(node))
			.length
		return selectedNodeCount <= 1
	}

	undoRedoRegisterCustomActions(undoRedo){
		this.undoRedoRegisterDataChangeAction(undoRedo)
		this.undoRedoRegisterPasteAction(undoRedo)
		this.undoRedoRegisterNodeGroupsChangeAction(undoRedo)
	}

	undoRedoRegisterDataChangeAction(undoRedo){
		console.log("undoRedoRegisterDataChangeAction")
		let action = (args) => {
			args = asArray(args)
			let res = []
			for(let arg of args){
				let {element, data} = arg
				console.log("undoRedo dataChange redo: ", args)
				let prevData = Object.assign({}, element.data())
				this.applyElementDataChange(element, data)
				res.push({element, data: prevData})
			}
			return res
		}

		let undo = (args) => {
			args = asArray(args)
			let res = []
			for (let arg of args){
				let {element, data} = arg
				console.log("undoRedo dataChange undo: ", args)
				let nextData = Object.assign({}, element.data())
				this.applyElementDataChange(element, data)
				res.push({element, data: nextData})
			}
			return res
		}
		undoRedo.action("dataChange", action, undo)
	}

	undoRedoRegisterPasteAction(undoRedo) {
		undoRedo.action(
			"paste",
			({cpids}) => {
				console.log("undoRedo paste redo: cpids = ", cpids)
				// Do: paste elements

				// Return elements for undo
				return this._pasteInternal(cpids)
			},
			(cpids) => {
				console.log("undoRedo paste undo: cpids = ", cpids)
				// Undo: remove pasted elements
				this.cy.remove(cpids);
				// if (this._plugins.clipboard && this._plugins.clipboard.getLastPasted) {
				// 	const pasted = this._plugins.clipboard.getLastPasted();
				// 	if (pasted) {
				// 		this.cy.remove(pasted);
				// 	}
				// }
				this.invalidateLabelFontSize();
				return cpids;
			}
		);
	}

	undoRedoRegisterNodeGroupsChangeAction(undoRedo) {
		let action = ({groups = [], syncRenderedGroups = true} = {}) => {
			let prevGroups = this.cloneNodeGroups(this.genogramItem?.nodeGroups || [])
			this.applyNodeGroups(groups, {syncRenderedGroups})
			return {groups: prevGroups, syncRenderedGroups}
		}

		let undo = ({groups = [], syncRenderedGroups = true} = {}) => {
			let nextGroups = this.cloneNodeGroups(this.genogramItem?.nodeGroups || [])
			this.applyNodeGroups(groups, {syncRenderedGroups})
			return {groups: nextGroups, syncRenderedGroups}
		}

		undoRedo.action("nodeGroupsChange", action, undo)
	}

	cloneNodeGroups(groups = []) {
		return JSON.parse(JSON.stringify(groups))
	}

	applyNodeGroups(groups = [], options = {}) {
		let {syncRenderedGroups = true} = options
		let nextGroups = this.cloneNodeGroups(groups)
		if(this.genogramItem){
			this.genogramItem.nodeGroups = nextGroups
		}
		if(syncRenderedGroups){
			this.nodeGroupsManager?.syncRenderedGroups()
		}
		this.nodeGroupsManager?.onGroupsChanged(nextGroups)
	}

	requestNodeGroupsChange(groups = [], options = {}) {
		let {syncRenderedGroups = true} = options
		if(this._plugins.undoRedo){
			this._undoRedoAction("nodeGroupsChange", {groups, syncRenderedGroups})
			return
		}
		this.applyNodeGroups(groups, {syncRenderedGroups})
	}

	invalidateLabelFontSize(){
		// let step = 5
		// var dim = Math.floor(12/this.cy.zoom() / step) * step
		// var maxDim = Math.min(30, Math.max(dim,20))
		let maxDim = 20//we no longer chnage font size based on zoom because this messes up layout for printing.
		console.log('zoom changed = ', this.cy.zoom(), maxDim)
		this.cy.nodes().css('font-size', maxDim);
		this.cy.edges().css('font-size', 16);
	}

	syncEdgeLabels(){
		GenogramEdgeLabelManager.syncAllEdgeLabels(this.cy)
	}

	syncNodeGroups(){
		this.nodeGroupsManager?.syncRenderedGroups()
	}

	setData(element, data){
		console.log("setData: element = ", element, ", data = ", data)
		if(this._plugins.undoRedo){
			this._undoRedoAction("dataChange", {element, data})
		} else {
			this.applyElementDataChange(element, data)
		}
	}

	applyElementDataChange(element, data){
		element.data(data)
		if(!element.isNode()){
			return
		}
		element._private.backgroundTimestamp = Date.now()
		element.emitAndNotify('background')
		this.syncNodeDependentLayoutAfterRender({type: "data"}, element)
	}

	removeAuxNodeIfNoEdges(nodes){
		for(let node of nodes){
			console.log("removeAuxNodeIfNoEdges: ", node)
			if(node.length === 0){
				continue;
			}

			if(node.data().isAuxNode && node.connectedEdges().length === 0){
				this.cy.remove(node)
				console.log("removeAuxNodeIfNoEdges is aux: ", node)
			}
		}
	}


	onAuxNodeRemoved(auxNode){
		console.log("onAuxNodeRemoved: ", auxNode)
		let {id, parentEdgeId, childNodeId} = auxNode.data()
		let parentEdge = this.cy.getElementById(parentEdgeId)
		let childNode = this.cy.getElementById(childNodeId)
		this.cleanupAuxEdgeData(id, parentEdge)
		this.cleanupAuxChildNodeData(id, childNode)

	}

	cleanupAuxEdgeData(auxNodeId, parentEdge){
		if(parentEdge.length === 0){
			return
		}
		let {auxNodes} = parentEdge.data()
		console.log("onAuxNodeRemoved: parentEdge = ", parentEdge)
		if(auxNodes){
			let index = auxNodes.findIndex(nodeId => nodeId === auxNodeId)
			if(index >= 0){
				auxNodes.splice(index, 1)
				parentEdge.data({auxNodes})
			}
		}
	}

	cleanupAuxChildNodeData(auxNodeId, childNode){
		if(childNode.length === 0){
			return
		}
		let {auxNodes} = childNode.data()
		if(auxNodes){
			let index = auxNodes.findIndex(nodeId => nodeId === auxNodeId)
			if(index >= 0){
				auxNodes.splice(index, 1)
				childNode.data({auxNodes})
			}
		}
	}

	_snapGridChange() {
		if (!this._plugins.cySnapToGrid) return
		if (this.editorOptions.snapGrid) {
			this._plugins.cySnapToGrid.gridOn()
			this._plugins.cySnapToGrid.snapOn()
		} else {
			this._plugins.cySnapToGrid.gridOff()
			this._plugins.cySnapToGrid.snapOff()
		}
	}

	_edgeParams() {
		let value = resolveLineTypeItemByLineType(this.editorOptions.lineType, this.editorOptions.customConnectionsSyncManager) || straightLine
		console.log("_edgeParams: ", value, this.editorOptions.lineType)
		return {
			data: this.edgeData(value)
		}
	}

	edgeData(lineTypeItem = {}) {
		let data = {
			connectionCategory: lineTypeItem.connectionCategory,
			lineType: "bezier",
			title: lineTypeItem.title,
			lineSubType: lineTypeItem.lineType,
			// lineStyle: lineTypeItem.lineStyle
		}

		if(lineTypeItem.connectionCategory === GenogramConnectionCategoryEnum.SOCIAL) {
			return {
				...data,
				lineType: "segments"
			}
		}
		return data
	}

	getCustomConnectionRenderConfigByLineSubType(lineSubType = "") {
		return this.editorOptions.customConnectionsSyncManager?.getRenderConfigByLineSubType?.(lineSubType) || null
	}

	_lineTypeChange(value) {
		console.log("_lineTypeChange: ", value)
		let selected = this.cy.$('edge:selected')
		// if (selected.length < 1) {
		//   selected = this.cy.$('edge')
		// }
		selected.forEach(item => {
			// let lineTypePrev = item.pstyle('curve-style').value || null
			this.setData(item, this.edgeData(value))
		})
		if(selected.length){
			this.cy.trigger('afterLineTypeChange', selected)
		}
	}

	_handleCommand(evt, item) {
		console.log("_handleCommand: ", item)

		if(this.cyOptions.readonly){
			let allowedCommands = ['zoomin', 'zoomout', 'fit']
			if(!allowedCommands.includes(item.command)){
				return
			}
		}

		if(item.lineType){
			return this.setOption('lineType', item)
		}
		switch (item.command) {
			case 'undo' :
				this.undo()
				break
			case 'redo' :
				this.redo()
				break
			case 'gridon' :
				this.toggleGrid()
				break
			case 'zoomin' :
				this.zoom(1)
				break
			case 'zoomout' :
				this.zoom(-1)
				break
			case 'levelup' :
				this.changeLevel(1)
				break
			case 'leveldown' :
				this.changeLevel(-1)
				break
			case 'copy' :
				this.copy()
				break
			case 'paste' :
				this.paste()
				break
			case 'fit' :
				this.fit()
				break
			case 'save' :
				this.save()
				break
			case 'savePng' :
				this.savePng()
				break
			case 'savePdf' :
				this.savePdf()
				break
			case 'delete' :
				this.deleteSelected()
				break
			case 'selectall' :
				this.selectAll()
				break

			case 'toggleLeftPanel':
				this.toggleLeftPanel()
				break

			case 'boxselect':
				this.selectionModeController.handleBoxSelectToolbarCommand(item.selected)
				break
			case GROUP_COMMAND:
				if(this.nodeGroupsManager.isGroupingModeActive){
					this.nodeGroupsManager.cancelGroupingMode()
				} else {
					let selectedNodes = this.cy.nodes(":selected")
						.filter(node => !node.data("isAuxNode"))
					let selectedNodeIds = selectedNodes.map(node => node.id())
					let initialNodeIds = selectedNodeIds
					this.nodeGroupsManager.startGroupingMode(initialNodeIds)
				}
				break
			default:
				break
		}
		this.analyticsManager.trackEvent("Command", {
			command: item.command,
			source: item.context === "Genogram Keyboard Shortcut used" ? "keyboard" : "toolbar",
			context: item.context || "Genogram Toolbar clicked",
			selected: item.selected
		})

	}

	_changeUndoRedo() {
		if (!this._plugins.undoRedo || !this._plugins.toolbar) return
		this.syncAuxReferencesFromGraph()
		let canRedo = this._plugins.undoRedo.isRedoStackEmpty()
		let canUndo = this._plugins.undoRedo.isUndoStackEmpty()
		if (canRedo !== this.lastCanRedo || canUndo !== this.lastCanUndo) {
			this._plugins.toolbar.rerender('undo', {disabled: canUndo})
			this._plugins.toolbar.rerender('redo', {disabled: canRedo})
		}
		this.lastCanRedo = canRedo
		this.lastCanUndo = canUndo
	}

	_undoRedoAction(cmd, options) {
		console.log("undoRedo: do cmd = ", cmd, options)
		this._doAction = cmd
		this._plugins.undoRedo.do(cmd, options)
	}

	_hook(hook, params, result = false) {
		if (typeof this.editorOptions[hook] === 'function') {
			const res = this.editorOptions[hook](params)
			return result ? res : true
		}
	}

	/**
	 * change editor option, support snapGrid, lineType
	 * @param {string|object} key
	 * @param {*} value
	 */
	setOption(key, value) {
		if (typeof key === 'string') {
			this.editorOptions[key] = value
			if (typeof this._handleOptonsChange[key] === 'function') {
				this._handleOptonsChange[key].call(this, value)
			}
		} else if (typeof key === 'object') {
			Object.assign(this.editorOptions, key)
		}
		if(key === "lineType"){
			this.cy.trigger('cyeditor.linetype')
		}
	}

	undo() {
		if (this._plugins.undoRedo) {
			let stack = this._plugins.undoRedo.getRedoStack()
			console.log("undoRedo: undo stack = ", stack)
			if (stack.length) {
				this._doAction = stack[stack.length - 1].action
			}
			let res = this._plugins.undoRedo.undo()
			if(res && res.move){
				this.cy.nodes().forEach(node => node.trigger("dragfree"))
			}
			this.cy.trigger('cyeditor.undo')
		} else {
			console.warn('Can not `undo`, please check the initialize option `editor.toolbar`')
		}
	}

	redo() {
		if (this._plugins.undoRedo) {
			let stack = this._plugins.undoRedo.getUndoStack()
			console.log("undoRedo: redo stack = ", stack)

			if (stack.length) {
				this._doAction = stack[stack.length - 1].action
			}
			let res = this._plugins.undoRedo.redo()
			if(res && res.move){
				this.cy.nodes().forEach(node => node.trigger("dragfree"))
			}
			this.cy.trigger('cyeditor.redo')
		} else {
			console.warn('Can not `redo`, please check the initialize option `editor.toolbar`')
		}
	}

	copy() {
		if (this._plugins.clipboard) {
			let selected = this.cy.$(':selected')
			if (selected.length) {
				this._cpids = this._plugins.clipboard.copy(selected)
				if (this._cpids && this._plugins.toolbar) {
					this._plugins.toolbar.rerender('paste', {disabled: false})
				}
			}
		} else {
			console.warn('Can not `copy`, please check the initialize option `editor.toolbar`')
		}
	}

	paste() {
		if (this._plugins.clipboard) {
			if (this._cpids) {
				if (this._plugins.undoRedo) {
					this._undoRedoAction('paste', {ids: this._cpids});
				} else {
					this._pasteInternal(this._cpids)
				}
			}
		} else {
			console.warn('Can not `paste`, please check the initialize option `editor.toolbar`')
		}
	}

	_pasteInternal(cpids) {
		let res = this._plugins.clipboard.paste(cpids);
		this.invalidateLabelFontSize();
		return res
	}

	changeLevel(type = 0) {
		let selected = this.cy.$(':selected')
		if (selected.length) {
			selected.forEach(el => {
				let pre = el.style()
				el.style('z-index', pre.zIndex - 0 + type > -1 ? pre.zIndex - 0 + type : 0)
			})
		}
	}

	async toggleLeftPanel(){
		console.log("toggleLeftPanel")
		if(await this.notifyAction("toggleLeftPanel") === true){
			this.redrawGrid()
		}
	}



	async notifyAction(action, data){
		if(typeof this.editorOptions.actionListener === 'function'){
			let res = await this.editorOptions.actionListener({action}, data)
			console.log("Genogram.notifyAction: res = ", res)
			return res
		}
		return NO_LISTENER
	}

	redrawGrid(){
		window.dispatchEvent(new CustomEvent('resize'))
	}

	refreshViewport() {
		this.cy?.resize()
		this._plugins.cySnapToGrid?.refresh()
	}

	deleteSelected() {
		let selected = this.cy.$(':selected')
		selected = selected.filter(item => !item.data('nonDeletable'))
		if (selected.length) {
			let elementsToDelete = this.getElementsWithDeleteCascade(selected)
			if (this._plugins.undoRedo) {
				this._undoRedoAction('remove', elementsToDelete)
			} else {
				this.cy.remove(elementsToDelete)
			}
			this.cy.trigger('cyeditor.remove')
		}
	}

	deleteByIds(idsToDelete = []) {
		if(idsToDelete.length === 0){
			return
		}
		let selector = idsToDelete.map(id => `[id="${id}"]`).join(", ")
		let elements = this.cy.filter(selector)
		if (elements.length) {
			let elementsToDelete = this.getElementsWithDeleteCascade(elements)
			if (this._plugins.undoRedo) {
				this._undoRedoAction('remove', elementsToDelete)
			} else {
				this.cy.remove(elementsToDelete)
			}
			this.cy.trigger('cyeditor.remove')
		}
	}

	getElementsWithDeleteCascade(elements) {
		let elementsToDelete = this.cy.collection(elements)
			.union(this.cy.collection(elements).connectedEdges())
		let hasChanges = true
		while(hasChanges){
			hasChanges = false
			let familyEdges = elementsToDelete.edges().filter(edge => edge.data("lineSubType")?.startsWith?.("family-"))
			for(let edge of familyEdges){
				let auxNodeIds = edge.data("auxNodes") || []
				for(let auxNodeId of auxNodeIds){
					let auxNode = this.cy.getElementById(auxNodeId)
					if(!auxNode?.nonempty?.() || elementsToDelete.anySame(auxNode)){
						continue
					}
					elementsToDelete = elementsToDelete.union(auxNode).union(auxNode.connectedEdges())
					hasChanges = true
				}
			}

			let candidateAuxNodes = this.cy.nodes().filter(node => {
				return node.data("isAuxNode") && !elementsToDelete.anySame(node)
			})
			for(let auxNode of candidateAuxNodes){
				let connectedEdges = auxNode.connectedEdges()
				if(!connectedEdges.nonempty?.()){
					continue
				}
				let willLoseAllEdges = connectedEdges.every(edge => elementsToDelete.anySame(edge))
				if(!willLoseAllEdges){
					continue
				}
				elementsToDelete = elementsToDelete.union(auxNode).union(connectedEdges)
				hasChanges = true
			}
		}
		return elementsToDelete
	}

	syncAuxReferencesFromGraph() {
		let auxNodeIdsByParentEdgeId = new Map()
		let auxNodeIdsByChildNodeId = new Map()
		this.cy.nodes().filter(node => node.data("isAuxNode")).forEach(node => {
			let {id, parentEdgeId, childNodeId} = node.data()
			if(parentEdgeId){
				let auxNodeIds = auxNodeIdsByParentEdgeId.get(parentEdgeId) || []
				auxNodeIds.push(id)
				auxNodeIdsByParentEdgeId.set(parentEdgeId, auxNodeIds)
			}
			if(childNodeId){
				let auxNodeIds = auxNodeIdsByChildNodeId.get(childNodeId) || []
				auxNodeIds.push(id)
				auxNodeIdsByChildNodeId.set(childNodeId, auxNodeIds)
			}
		})

		this.cy.edges().forEach(edge => {
			edge.data({auxNodes: auxNodeIdsByParentEdgeId.get(edge.id()) || []})
		})
		this.cy.nodes().filter(node => !node.data("isAuxNode")).forEach(node => {
			node.data({auxNodes: auxNodeIdsByChildNodeId.get(node.id()) || []})
		})
	}

	isGroupingModeActive() {
		return !!this.nodeGroupsManager?.isGroupingModeActive
	}

	async saveNodeGroupDraft() {
		let isSaved = this.nodeGroupsManager?.saveDraftGroup()
		if(isSaved){
			return true
		}
		if(this.nodeGroupsManager?.isGroupingModeActive){
			let selectedNodeCount = this.cy.nodes(":selected")
				.filter(node => !node.data("isAuxNode"))
				.length
			if(selectedNodeCount < 2){
				await this.notifyAction("showToastInfo", {
					message: "Select at least 2 people to save a group.",
					duration: 3000,
				})
			}
		}
		return false
	}

	setDraftNodeGroupColor(color) {
		this.nodeGroupsManager?.setDraftGroupColor(color)
	}

	setDraftNodeGroupTitle(title) {
		this.nodeGroupsManager?.setDraftGroupTitle(title)
	}

	cancelNodeGroupDraft() {
		this.nodeGroupsManager?.cancelGroupingMode()
	}

	startNodeGroup(nodeId) {
		if(!nodeId){
			return
		}
		this.nodeGroupsManager?.startGroupingMode([nodeId])
	}

	deleteEditingNodeGroups() {
		this.nodeGroupsManager?.deleteEditingGroups()
	}

	removeNodeFromAllGroups(nodeId) {
		this.nodeGroupsManager?.removeNodeFromAllGroups(nodeId)
	}

		editNodeGroup(groupId) {
			return this.nodeGroupsManager?.startEditingGroup(groupId)
		}

	deleteRelatedGroups(nodeId) {
		this.nodeGroupsManager?.deleteGroupsByNodeId(nodeId)
	}

	getGroupsForNode(nodeId) {
		return this.nodeGroupsManager?.getGroupsForNode(nodeId) || []
	}

	async onBeforeSave(){
		let res = await this.notifyAction("exportGenogram")
		console.log("Genogram.onBeforeSave: res = ", res)
		return res === NO_LISTENER || res //return true if no listener, otherwise return the result
	}

	async save() {
		return this.savePng()
	}

	async savePng() {
		return this.saveExport({
			format: "png",
			exportMethod: () => this.saveGenogramPng(),
		})
	}

	async savePdf() {
		return this.saveExport({
			format: "pdf",
			exportMethod: () => this.saveGenogramPdf(),
		})
	}

	async saveExport({format, exportMethod}) {
		this.unselectAll()
		let boundingBox = this.cy.elements().boundingBox();
		console.log("getGenogramBase64Image: boundingBox = ", boundingBox)

		if(this.shouldShowLegacyOversizeExportWarning(boundingBox, format)){
			let timesVar = Math.max(boundingBox.w / 10000, boundingBox.h / 10000)
			if(timesVar < 2){
				timesVar = "a bit"
			} else {
				timesVar = Math.ceil(timesVar) + " times"
			}
			let res = await this.notifyAction("showMessageYesNo", {
				title: "Genogram is too wide",
				message: `The resulting export may have poor quality or may fail entirely.<br/><br/>Please try to make your genogram ${timesVar} more compact and try again.`,
				okTitle: "Try exporting anyway",
			})
			if(!res){
				return
			}
		}

		if(!await this.onBeforeSave()){
			return
		}
		try{
			await this.emit("requestClearLegendInteraction")
			await exportMethod()
			this.analyticsManager.trackEvent("Genogram Save clicked", {
				format,
				label: this.editorOptions.showWatermark ? "watermark added" : "no watermark"
			})
			await this.notifyAction("analyticsExportCompleted", {format})
		} catch (e) {
			console.error(e)
			try {
				await messageDialog({
					title: "Can't export genogram",
					message: "Try to make the genogram tighter and try again.",
				})
			} catch (dialogError) {
				console.error(dialogError)
			}
		} finally {
			await this.notifyAction("exportGenogramCompleted")
		}
	}

	shouldShowLegacyOversizeExportWarning(boundingBox, format) {
		if (!LEGACY_OVERSIZE_EXPORT_WARNING_ENABLED) {
			return false
		}

		if (format === "png" && this.shouldUseTiledPngExportByHeuristics(boundingBox)) {
			return false
		}

		return boundingBox.w > 10000 || boundingBox.h > 10000
	}



	async saveGenogramPng(){
		let exportOutput = await this.getPngExportOutput()
		this.downloadExportOutput(exportOutput)
	}

	async saveGenogramPdf(){
		let exportOutput = await this.getPdfExportOutput()
		this.downloadExportOutput(exportOutput)
	}

	downloadExportOutput(exportOutput) {
		let a = document.createElement('a')
		a.download = `my-genogram.${exportOutput.extension}`
		a.href = exportOutput.dataUrl
		a.click()
		a.remove()
	}

	async getPngExportOutput() {
		let exportOutput = null
		let bounds = this.cy.elements().boundingBox()
		let exportId = timeNow() + "-" + Math.round(Math.random() * 100000)
		let forcedExportMode = this.getForcedGenogramExportMode()
		this.logStandardPngExportDiagnostic("RouteStart", {
			exportId,
			bounds: this.serializeBoundingBox(bounds),
			forcedExportMode,
			shouldUseTiledPngExportByHeuristics: this.shouldUseTiledPngExportByHeuristics(bounds),
		})

		if (forcedExportMode === GENOGRAM_EXPORT_MODE.FULL) {
			console.log(`${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} Forced standard PNG export enabled`)
			this.logStandardPngExportDiagnostic("RouteSelected", {
				exportId,
				route: "standard-forced",
			})
			exportOutput = await this.getStandardPngExportOutput()
			this.logStandardPngExportDiagnostic("RouteCompleted", {
				exportId,
				route: "standard-forced",
				outputWidth: exportOutput?.width,
				outputHeight: exportOutput?.height,
			})
			return exportOutput
		}

		if (forcedExportMode === GENOGRAM_EXPORT_MODE.TILED) {
			console.log(`${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} Forced tiled PNG export enabled`)
			this.logStandardPngExportDiagnostic("RouteSelected", {
				exportId,
				route: "tiled-forced",
			})
			return await this.getTiledPngExportOutput()
		}

		if (this.shouldUseTiledPngExportByHeuristics(bounds)) {
			console.log(`${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} Heuristic selected tiled PNG export`)
			this.logStandardPngExportDiagnostic("RouteSelected", {
				exportId,
				route: "tiled-heuristic",
			})
			return await this.getTiledPngExportOutput()
		}

		try {
			this.logStandardPngExportDiagnostic("RouteSelected", {
				exportId,
				route: "standard",
			})
			exportOutput = await this.getStandardPngExportOutput()
			this.logStandardPngExportDiagnostic("RouteCompleted", {
				exportId,
				route: "standard",
				outputWidth: exportOutput?.width,
				outputHeight: exportOutput?.height,
			})
		} catch (error) {
			console.error(error)
			console.warn(`${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} Standard PNG export failed, switching to tiled export`, error)
			this.logStandardPngExportDiagnostic("RouteFallback", {
				exportId,
				route: "standard-to-tiled",
				errorMessage: error?.message || String(error),
			})
			exportOutput = await this.getTiledPngExportOutput()
		}

		return exportOutput
	}

	getForcedGenogramExportMode() {
		if (!this.isDebugExportModeEnabled()) {
			return null
		}

		let queryOverride = this.getForcedGenogramExportModeQueryValue()
		return queryOverride || null
	}

	shouldUseTiledPngExportByHeuristics(bounds = null) {
		let nextBounds = bounds || this.cy.elements().boundingBox()
		let width = Math.ceil(nextBounds.w || 0)
		let height = Math.ceil(nextBounds.h || 0)
		let totalPixels = width * height

		return width > LOCAL_PNG_EXPORT_MAX_DIMENSION_PX
			|| height > LOCAL_PNG_EXPORT_MAX_DIMENSION_PX
			|| totalPixels > LOCAL_PNG_EXPORT_MAX_TOTAL_PIXELS
	}

	getForcedGenogramExportModeQueryValue() {
		if (typeof window === "undefined" || !window.location?.search) {
			return null
		}

		let params = new URLSearchParams(window.location.search)
		return this.normalizeForcedGenogramExportMode(params.get(GENOGRAM_FORCE_EXPORT_MODE_QUERY_PARAM))
	}

	normalizeForcedGenogramExportMode(mode) {
		if (mode === GENOGRAM_EXPORT_MODE.FULL || mode === GENOGRAM_EXPORT_MODE.TILED) {
			return mode
		}

		return null
	}

	shouldShowDebugTileBorders() {
		if (!this.isDebugExportModeEnabled()) {
			return false
		}

		let queryOverride = this.getDebugTileBordersQueryFlag()
		return queryOverride
	}

	isDebugExportModeEnabled() {
		return isDevEnv
	}

	getDebugTileBordersQueryFlag() {
		if (typeof window === "undefined" || !window.location?.search) {
			return false
		}

		let params = new URLSearchParams(window.location.search)
		return params.get(GENOGRAM_DEBUG_TILE_BORDERS_QUERY_PARAM) === "true"
	}

	async getStandardPngExportOutput() {
		let bounds = this.cy.elements().boundingBox()
		this.logStandardPngExportDiagnostic("StandardStart", {
			bounds: this.serializeBoundingBox(bounds),
		})
		let exportSourceImages = await this.getExportSourceImages()
		this.logStandardPngExportDiagnostic("StandardSourcesLoaded", {
			genogramWidth: exportSourceImages?.genogramImage?.width,
			genogramHeight: exportSourceImages?.genogramImage?.height,
			legendWidth: exportSourceImages?.legendImage?.width,
			legendHeight: exportSourceImages?.legendImage?.height,
		})
		let mergedImage = await this.getMergedExportImage(exportSourceImages, EXPORT_MERGE_MODE.SCREEN)
		let expectedCanvasSize = this.getScreenMergeCanvasSize(
			exportSourceImages.genogramImage,
			exportSourceImages.legendImage
		)
		this.logStandardPngExportDiagnostic("StandardMerged", {
			mergedWidth: mergedImage?.width,
			mergedHeight: mergedImage?.height,
			expectedMergedWidth: expectedCanvasSize?.width,
			expectedMergedHeight: expectedCanvasSize?.height,
		})
		this.assertValidPngExportOutput(mergedImage)

		return {
			dataUrl: mergedImage.dataUrl,
			mimeType: "image/png",
			extension: "png",
			width: mergedImage.width,
			height: mergedImage.height,
		}
	}

	assertValidPngExportOutput(mergedImage) {
		let isInvalid = !mergedImage?.dataUrl || !mergedImage?.width || !mergedImage?.height

		if (isInvalid) {
			this.logStandardPngExportDiagnostic("StandardInvalidOutput", {
				mergedWidth: mergedImage?.width,
				mergedHeight: mergedImage?.height,
				hasDataUrl: !!mergedImage?.dataUrl,
			})
			throw new Error("Genogram.assertValidPngExportOutput: empty PNG export output")
		}
	}

	logStandardPngExportDiagnostic(event, payload = {}) {
		console.log(`${STANDARD_PNG_EXPORT_DIAGNOSTIC_PREFIX} ${event}`, JSON.stringify(payload))
	}

	serializeBoundingBox(bounds = {}) {
		return {
			x1: bounds.x1,
			y1: bounds.y1,
			x2: bounds.x2,
			y2: bounds.y2,
			w: bounds.w,
			h: bounds.h,
		}
	}

	async getTiledPngExportOutput() {
		let bounds = this.cy.elements().boundingBox()
		let legendSource = await this.getLegendBase64Image()

		return await this.buildTiledExportOutput({
			bounds,
			legendSource,
			showWatermark: this.editorOptions.showWatermark,
			layoutMode: "screen",
		})
	}

	async buildTiledExportOutput({
		bounds,
		legendSource = null,
		showWatermark = false,
		layoutMode = "screen",
		maxLongSidePx = null,
		maxTotalPixels = null,
	}) {
		let exportOutput = null

		await this.notifyAction("setTiledExportMaskVisible", {isVisible: true})
		try {
			exportOutput = await this.tiledPngExportManager.buildExportOutput({
				cy: this.cy,
				bounds,
				legendSource,
				showWatermark,
				showDebugTileBorders: this.shouldShowDebugTileBorders(),
				layoutMode,
				maxLongSidePx,
				maxTotalPixels,
				onProgress: async ({capturedCount, tileCount}) => {
					this.logTiledExportProgress(capturedCount, tileCount)
				},
			})
		} finally {
			await this.notifyAction("setTiledExportMaskVisible", {isVisible: false})
		}

		return exportOutput
	}

	logPdfExportDiagnostic(event, payload = {}) {
		console.log(`${PDF_EXPORT_DIAGNOSTIC_PREFIX} ${event}`, JSON.stringify(payload))
	}

	logTiledExportProgress(capturedCount, tileCount) {
		let shouldLog = capturedCount === 1 || capturedCount === tileCount || capturedCount % 10 === 0

		if (shouldLog) {
			console.log(`${GENOGRAM_EXPORT_DIAGNOSTIC_PREFIX} Tiled PNG progress = `, JSON.stringify({
				capturedCount,
				tileCount,
			}))
		}
	}

	async getExportOutput(format = "png") {
		if (format === "png") {
			return await this.getPngExportOutput()
		}

		if (format === "pdf") {
			return await this.getPdfExportOutput()
		}

		throw new Error(`Unsupported genogram export format: ${format}`)
	}

	async getPdfExportOutput() {
		let bounds = this.cy.elements().boundingBox()
		let exportId = timeNow() + "-" + Math.round(Math.random() * 100000)
		let forcedExportMode = this.getForcedGenogramExportMode()
		let shouldUseTiledGenogramSource = this.shouldUseTiledGenogramExportSource(bounds)
		let exportOutput = null

		try {
			this.logPdfExportDiagnostic("RouteStart", {
				exportId,
				bounds: this.serializeBoundingBox(bounds),
				forcedExportMode,
				shouldUseTiledGenogramSource,
			})
			let genogramImage = await this.getPdfGenogramSourceImage(bounds, {
				exportId,
				forcedExportMode,
				shouldUseTiledGenogramSource,
			})
			let legendImageUrl = await this.getLegendBase64Image()
			let legendImage = await this.getImageFromSource(legendImageUrl)
			exportOutput = await this.buildPdfExportOutput({
				genogramImage,
				legendImage,
			})
			this.logPdfExportDiagnostic("RouteCompleted", {
				exportId,
				outputWidth: exportOutput?.width,
				outputHeight: exportOutput?.height,
			})
		} catch (error) {
			console.error(error)
			this.logPdfExportDiagnostic("RouteFailed", {
				exportId,
				errorMessage: error?.message || String(error),
			})
			throw error
		}

		return exportOutput
	}

	shouldUseTiledGenogramExportSource(bounds = null) {
		let forcedExportMode = this.getForcedGenogramExportMode()

		if (forcedExportMode === GENOGRAM_EXPORT_MODE.TILED) {
			return true
		}

		if (forcedExportMode === GENOGRAM_EXPORT_MODE.FULL) {
			return false
		}

		return this.shouldUseTiledPngExportByHeuristics(bounds)
	}

	async getPdfGenogramSourceImage(bounds, {exportId, shouldUseTiledGenogramSource}) {
		let genogramImageUrl = null

		if (shouldUseTiledGenogramSource) {
			this.logPdfExportDiagnostic("RouteSelected", {
				exportId,
				route: "tiled-genogram-source",
			})
			genogramImageUrl = await this.getTiledGenogramBase64Image(bounds)
		} else {
			this.logPdfExportDiagnostic("RouteSelected", {
				exportId,
				route: "full-genogram-source",
			})
			genogramImageUrl = await this.getGenogramBase64Image()
		}

		return await this.getImageFromSource(genogramImageUrl)
	}

	async getExportSourceImages() {
		let genogramImageUrl = await this.getGenogramBase64Image()
		let legendImageUrl = await this.getLegendBase64Image()
		let genogramImage = await this.getImageFromSource(genogramImageUrl)
		let legendImage = await this.getImageFromSource(legendImageUrl)

		return {
			genogramImage,
			legendImage,
		}
	}

	async getTiledGenogramBase64Image(bounds = null) {
		let nextBounds = bounds || this.cy.elements().boundingBox()
		let exportOutput = await this.buildTiledExportOutput({
			bounds: nextBounds,
			legendSource: null,
			showWatermark: false,
			layoutMode: "genogram-only",
			maxLongSidePx: PDF_TILED_EXPORT_MAX_LONG_SIDE_PX,
			maxTotalPixels: PDF_TILED_EXPORT_MAX_TOTAL_PIXELS,
		})

		return exportOutput.dataUrl
	}

	async getMergedExportImage({genogramImage, legendImage}, mode = EXPORT_MERGE_MODE.SCREEN) {
		let finalImage = await this.mergeTwoBase64Images(genogramImage, legendImage, mode)
		let image = await this.getImageFromSource(finalImage)

		return {
			dataUrl: finalImage,
			width: image.width,
			height: image.height,
		}
	}

	getImageFromSource(imgSrc) {
		return new Promise((resolved, reject) => {
			let image = new Image()
			image.onload = () => resolved(image)
			image.onerror = () => reject(new Error(`Genogram.getImageFromSource: failed to load image source`))
			image.src = imgSrc
		})
	}

	getScreenMergeCanvasSize(genogramImage, legendImage) {
		let layout = buildScreenExportLayout({
			genogramWidth: genogramImage.width,
			genogramHeight: genogramImage.height,
			legendWidth: legendImage.width,
			legendHeight: legendImage.height,
		})

		return {
			width: layout.width,
			height: layout.height,
		}
	}

	async mergeTwoBase64Images(genogramImage, legendImage, mode = EXPORT_MERGE_MODE.SCREEN){
		let layout = buildScreenExportLayout({
			genogramWidth: genogramImage.width,
			genogramHeight: genogramImage.height,
			legendWidth: legendImage.width,
			legendHeight: legendImage.height,
		})
		var canvas = document.createElement("canvas");
		canvas.width = layout.width
		canvas.height = layout.height


		// Copy the image contents to the canvas
		var ctx = canvas.getContext("2d");
		ctx.fillStyle = "white";
		ctx.fillRect(0, 0, canvas.width, canvas.height);


		ctx.drawImage(genogramImage, layout.padding, layout.padding);

		ctx.drawImage(legendImage, layout.legendLeft, layout.legendTop, layout.legendWidth, layout.legendHeight);
		drawLegendBorderToCanvas(ctx, layout)


		if(this.editorOptions.showWatermark){
			this.exportWatermarkHelper.applyToCanvas(ctx, canvas)
		}

		let finalImage = canvas.toDataURL("image/png");
		canvas.remove()
		return finalImage
	}

	async buildPdfExportOutput({genogramImage, legendImage}) {
		let pdfExportManagerModule = await import("@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramPdfExportManager")
		let pdfExportManager = new pdfExportManagerModule.default()
		return await pdfExportManager.buildExportOutput(genogramImage, legendImage, {
			showWatermark: this.editorOptions.showWatermark,
			watermarkHelper: this.exportWatermarkHelper,
		})
	}

	async getGenogramBase64Image(){
		let exportOptions = {
			maxWidth: 20000,
			output: 'blob-promise',
			bg: 'white',
			full: true,
			ignoreUnsupportedLayers: true,
			ignoreUnsupportedLayerOrder: true,
		}
		let blob
		if(this.cy.layers){
			blob = await this.cy.layers().jpg(exportOptions)
		} else {
			blob = await this.cy.jpg(exportOptions)
		}
		console.log("getGenogramBase64Image: blob = ", blob)
		return window.URL.createObjectURL(blob)
	}

	async getLegendBase64Image(){
		let emptyPng = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
		let image = await this.emit('requestLegendSnapshot')
		return image || emptyPng
	}

	fit() {
		this.cy.fit()
		// if (!this._fit_status) {
		// 	this._fit_status = {pan: this.cy.pan(), zoom: this.cy.zoom()}
		// 	this.cy.fit()
		// } else {
		// 	this.cy.viewport({
		// 		zoom: this._fit_status.zoom,
		// 		pan: this._fit_status.pan
		// 	})
		// 	this._fit_status = null
		// }
	}

	zoom(type = 1, level) {
		level = level || this.editorOptions.zoomRate
		let w = this.cy.width()
		let h = this.cy.height()
		let zoom = this.cy.zoom() + level * type
		let pan = this.cy.pan()
		// pan.x = pan.x + -1 * w * level * type / 2
		// pan.y = pan.y + -1 * h * level * type / 2
		console.log("zoom: ", w, h, zoom, pan)
		this.cy.zoom({
				level: zoom,
				renderedPosition: {
					x: w/2,
					y: h/2
				}
		})

		// this.cy.viewport({
		// 	zoom,
		// 	pan
		// })
	}

	toggleGrid() {
		if (this._plugins.cySnapToGrid) {
			this.setOption('snapGrid', !this.editorOptions.snapGrid)
		} else {
			console.warn('Can not `toggleGrid`, please check the initialize option')
		}
	}

	jpg(opt = {}) {
		return this.cy.png(opt)
	}

	png(opt) {
		return this.cy.png(opt)
	}

	/**
	 * Export the graph as JSON or Import the graph as JSON
	 * @param {*} opt params for cy.json(opt)
	 * @param {*} keys JSON Object keys
	 */
	json(opt = false, keys) {
		keys = keys || ['boxSelectionEnabled', 'elements', 'pan', 'panningEnabled', 'userPanningEnabled', 'userZoomingEnabled', 'zoom', 'zoomingEnabled']
		// export
		let json = {}
		if (typeof opt === 'boolean') {
			let cyjson = this.cy.json(opt)
			keys.forEach(key => {
				json[key] = cyjson[key]
			})
			return json
		}
		// import
		if (typeof opt === 'object') {
			json = {}
			keys.forEach(key => {
				json[key] = opt[key]
			})
		}

		return this.cy.json(json)
	}

	/**
	 * get or set data
	 * @param {string|object} name
	 * @param {*} value
	 */
	data(name, value) {
		return this.cy.data(name, value)
	}

	/**
	 *  remove data
	 * @param {string} names  split by space
	 */
	removeData(names) {
		this.cy.removeData(names)
	}

	destroy() {
		document.removeEventListener('keydown', this._listeners.handleDocumentKeyDown)
		this.cursorManager?.destroy()
		this.selectionModeController?.destroy()
		this.multiSelectHintController?.destroy()
		this.nodeGroupsManager?.destroy()
		this.primaryPersonOutlineRenderer?.destroy()
		this.sexualCommunicationBadgeRenderer?.destroy()
		this.manualConnectionTargetHintRenderer?.destroy()
		this.tiledPngExportManager?.destroy()
		this.cy.removeAllListeners()
		this.cy.destroy()
		this.keyActionListener.destroy()
	}
}

export default CyEditor
